import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { FaSearch, FaFilter, } from 'react-icons/fa';
import { BiSolidCategory } from "react-icons/bi";
import { css } from '@emotion/core';
import ClipLoader from 'react-spinners/ClipLoader';
import * as Constant from '../Constant';
import Header from '../Components/Header';
import NewFooter from './newfooter';
import './newUi.css'

const override = css`
  display: block;
  margin: 0 auto;
  border-color: #ea6123 solid 2px;
`;

const cookies = new Cookies();



const Programs = () => {
  const { category } = useParams(); // Menangkap kategori dari URL
  /* const [programs, setPrograms] = useState([]); // UNUSED */
  const [categories, setCategories] = useState([]); // Menyimpan kategori dari API
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(category || 'Semua'); // Default ke kategori dari URL atau "Semua"


  const [yayasanId, setYayasanId] = useState(cookies.get("id_yayasan"));

  /* 
   * MENGGUNAKAN AXIOS: Mengganti fetch dengan axios untuk konsistensi dengan Program.js
   * dan menghindari masalah parsing JSON manual serta cors headers yang mungkin berbeda.
   */
  // Helper untuk parsing JSON aman
  const safeJsonParse = (data) => {
    if (typeof data === 'object') return data; // Sudah JSON (dari axios default behavior jika transformResponse tidak override)
    try {
      return JSON.parse(data);
    } catch (e) {
      return null;
    }
  };

  const axiosConfig = {
    headers: {
      'X-API-KEY': Constant.X_API_KEY
    },
    transformResponse: [function (data) {
      // Do not parse JSON automatically to avoid crash on HTML response
      return data;
    }]
  };

  useEffect(() => {
    const initYayasanAndCategories = async () => {
      let currentId = cookies.get("id_yayasan");

      // 1. Cek dan Fetch ID Yayasan jika belum ada
      if (!currentId) {
        try {
          const response = await axios.get(Constant.GET_YAYASAN, axiosConfig);
          const data = safeJsonParse(response.data);

          if (data && data.status === 200 && data.data) {
            currentId = data.data.id;
            cookies.set("id_yayasan", currentId, { path: '/' });
            setYayasanId(currentId);
          } else {
            console.error("Failed to parse Yayasan ID response or invalid status", response.data);
          }
        } catch (error) {
          console.error('Error fetching yayasan ID:', error);
        }
      } else {
        setYayasanId(currentId);
      }

      // 2. Fetch Categories (hanya jika id_yayasan ada)
      if (currentId) {
        try {
          const response = await axios.get(`${Constant.GET_CATEGORIES}?id_yayasan=${currentId}`, axiosConfig);
          const data = safeJsonParse(response.data);

          if (data && data.status === 200 && Array.isArray(data.data)) {
            setCategories([
              { id: null, category: 'Semua' },
              ...data.data.map(cat => ({ id: cat.id, category: cat.category })),
            ]);
          } else {
            console.error("Failed to parse Categories response or invalid status", response.data);
          }
        } catch (error) {
          console.error('Error fetching categories:', error);
        }
      }
    };

    initYayasanAndCategories();
  }, []);

  useEffect(() => {
    const fetchPrograms = async () => {
      // Tunggu sampai yayasanId ada
      if (!yayasanId) return;

      setLoading(true);
      try {
        let query_url = `?page=1`;
        query_url += `&id_yayasan=${yayasanId}`;

        if (searchTerm) query_url += `&keyword=${searchTerm}`;

        if (category && categories.length > 0) {
          const selectedCat = categories.find(cat => cat.category.toLowerCase() === category.toLowerCase());
          if (selectedCat && selectedCat.id) {
            query_url += `&idKategori=${selectedCat.id}`;
          }
        }

        console.log("Fetching Programs URL:", `${Constant.GET_PROGRAMS}${query_url}`); // Debugging

        const response = await axios.get(`${Constant.GET_PROGRAMS}${query_url}`, axiosConfig);
        const result = safeJsonParse(response.data);

        if (result && Array.isArray(result.data)) {
          console.log(`API returned ${result.data.length} programs.`);
          console.log(`Filtering by category: "${category || 'ALL'}"`);

          const filteredByCategory = result.data.filter(program => {
            if (!category || category.toLowerCase() === 'semua') return true;
            const progCat = program.program?.kategori?.category?.toLowerCase();
            return progCat === category.toLowerCase();
          });

          console.log(`Filtered count: ${filteredByCategory.length}`);
          if (filteredByCategory.length === 0 && result.data.length > 0) {
            console.log("Categories found in data:", result.data.map(p => p.program?.kategori?.category));
          }

          /* setPrograms(filteredByCategory); // UNUSED */
          setFilteredPrograms(filteredByCategory);
        } else {
          console.error('Unexpected API response for programs:', response.data);
        }
      } catch (error) {
        console.error('Error fetching programs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrograms();
  }, [category, categories, searchTerm, yayasanId]);

  const handleCategoryChange = (newCategory) => {
    setSelectedCategory(newCategory); // Update state
    const baseUrl = window.location.origin;
    const newUrl = newCategory === 'Semua' ? `${baseUrl}/programs` : `${baseUrl}/programs/${newCategory}`;
    window.location.href = newUrl; // Mengubah URL dan memuat ulang halaman
  };
  const getFilterIconAndText = () => {
    const selectedCategory = categories.find(
      cat => cat.category && cat.category.toLowerCase() === (category || 'semua').toLowerCase()
    );

    if (!selectedCategory || selectedCategory.category.toLowerCase() === 'semua') {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <FaFilter style={{ color: '#fff', fontSize: '20px' }} />
          <span style={{ color: '#fff', fontWeight: 'bold' }}></span>
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          bottom: '30px',
        }}
      >
        <img
          src={`${Constant.GET_CATEGORY_ICON}/${selectedCategory.id}`}
          alt={selectedCategory.category}
          style={{ height: '40px', marginBottom: '5px', color: '#EA6022', backgroundColor: 'white', borderRadius: '50%', padding: '5px' }}
        />
        <span style={{ color: '#fff', fontWeight: 'bold' }}>{selectedCategory.category}</span>
      </div>
    );
  };


  return (
    <div>
      <Header />
      <div className="programs-container">
        <div
          className="search-filter-panel"
          style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', marginRight: '10px', marginLeft: '10px' }}
        >
          {/* Search Bar */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
              borderRadius: '25px',
              overflow: 'hidden',
              boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#fff',
              width: '100%',
              height: '45px',
              maxWidth: '400px',
              flexGrow: 1,
            }}
          >
            <FaSearch style={{ marginLeft: '10px', color: '#aaa' }} />
            <input
              type="text"
              placeholder="Cari program..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{
                flexGrow: 1,
                padding: '10px 15px',
                border: 'none',
                outline: 'none',
                height: '40px', // Ensures the height is fixed
              }}
              autoFocus={!category}
            />
          </div>

          {/* Filter Button */}
          <button
            onClick={() => setShowModal(!showModal)}
            style={{
              padding: '10px 15px',
              backgroundColor: 'transparent', // Remove background color
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center', // Ensures icon and text are centered
              outline: 'none', // Menghilangkan efek outline
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'transparent'}  // Menghilangkan perubahan warna saat hover
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            className='button-filter'
          >
            {getFilterIconAndText()}
          </button>
        </div>

        {/* Category Modal */}
        {showModal && (
          <div
            className="category-modal"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1000,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start', // Modal muncul dari atas
              overflow: 'hidden',
            }}
            onClick={() => setShowModal(false)}
          >
            <div
              style={{
                backgroundColor: '#fff',
                borderRadius: '15px',
                padding: '20px',
                width: '90%',
                maxWidth: '600px',
                maxHeight: '400px',
                overflowY: 'auto',
                transform: showModal ? 'translateY(0)' : 'translateY(-100%)',
                transition: 'transform 0.4s ease-in-out', // Tambahkan transisi
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Pilih Kategori</h3>
              <div>
                {/* Kategori "Semua" */}
                {categories.filter(cat => cat.category === 'Semua').map(({ id, category }) => (
                  <button
                    key={id}
                    onClick={() => handleCategoryChange(category)}
                    style={{
                      padding: '10px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: 'white',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginBottom: '20px',
                    }}
                  >
                    <BiSolidCategory style={{
                      height: '40px', width: 'auto', color: '#000', marginBottom: '5px', backgroundColor: '#f7f7f7', borderRadius: '50%', padding: '5px',
                      border: selectedCategory === category ? '3px solid #EA6022' : '1px solid transparent',
                    }} />
                    <span style={{ fontSize: '12px' }}>{category}</span>
                  </button>
                ))}

                {/* Kategori lainnya */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '10px',
                  }}
                >
                  {categories
                    .filter(cat => cat.category !== 'Semua')
                    .map(({ id, category }) => (
                      <button
                        key={id}
                        onClick={() => handleCategoryChange(category)}
                        style={{
                          padding: '5px',
                          textAlign: 'center',
                          backgroundColor: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={`${Constant.GET_CATEGORY_ICON}/${id}`}
                          alt={category}
                          style={{
                            height: '40px',
                            marginBottom: '5px',
                            backgroundColor: '#f7f7f7',
                            borderRadius: '50%',
                            padding: '5px',
                            border: selectedCategory === category ? '3px solid #EA6022' : '1px solid transparent',
                            boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
                          }}
                        />
                        <span style={{ fontSize: '12px' }}>{category}</span>
                      </button>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}



        {/* Program List */}
        <div style={{ width: '100%', }}>
          {loading ? (
            <div className="loader-container">
              <ClipLoader color="#ea6123" loading={loading} css={override} size={150} />
            </div>
          ) : filteredPrograms.length > 0 ? (
            filteredPrograms.map((program, i) => {
              const image_link = `${Constant.GET_PROGRAMS_IMAGE}${program.id_program}`;
              let total = 0;

              program.program.donatur.forEach(donatur => {
                total += donatur.total;
              });

              let percent = (total / program.program.dana_target) * 100;
              if (percent > 100) percent = 100;

              let today = Date.now();
              let final_day = new Date(program.program.tanggal);
              let day_remaining = Math.ceil((final_day - today) / (1000 * 60 * 60 * 24));

              if (!program.program.tanggal) {
                final_day = null;
                day_remaining = '∞';
              }

              return (
                <Link to={`/detailprogram/${program.seo}`} key={i}>
                  <div className="content-boxed">
                    <div className="content" id="program-list-content" style={{ height: 'auto' }}>
                      <img
                        className="program-home-image"
                        src={image_link}
                        alt={program.judul}
                      />
                      <div className="program-desc">
                        <h6 className="title-program">{program.judul}</h6>
                        <i>
                          <p className="category-program">
                            {program.program.kategori.category}
                          </p>
                        </i>
                        <div className="w3-light-grey">
                          <div
                            className="w3-red"
                            style={{
                              height: '5px',
                              width: `${percent}%`,
                            }}
                          ></div>
                        </div>
                        <div className="dana" style={{ marginTop: '10px' }}>
                          {day_remaining < 0 ? (
                            <div className="penggalangan-terlewat">
                              Penggalangan dana sudah berakhir <br />
                              <div className="dana-terkumpul">
                                Terkumpul <br />
                                <b>
                                  <p>
                                    {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' })
                                      .format(total)
                                      .replace(',00', '')}
                                  </p>
                                </b>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="dana-terkumpul">
                                Terkumpul <br />
                                <b>
                                  <p>
                                    {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' })
                                      .format(total)
                                      .replace(',00', '')}
                                  </p>
                                </b>
                              </div>
                              <div className="sisa-hari">
                                Sisa Hari <br />
                                <b>
                                  <p>{day_remaining}</p>
                                </b>
                              </div>
                            </>
                          )}
                        </div>
                        <p>{String(program.resume).substring(0, 50)}...</p>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })
          ) : (
            <div>No programs available in this category.</div>
          )}
        </div>
      </div>
      <NewFooter />
    </div>
  );
};

export default Programs;
